const routerArr = [
  {
      path: '/before_live',
      name: 'LiveExam',
      meta: { title:'考场纪律' ,login:false},
      component: () => import(/* webpackChunkName: 'examLive' */ './page/LiveExam.vue'),
  },
  {
    path: '/device_check',
    name: 'DeviceCheck',
    meta: { title:'学习' ,login:false},
    component: () => import(/* webpackChunkName: 'examLive' */ './page/DeviceCheck.vue'),
  },
  {
    path: '/exam_live',
    name: 'exam_live',
    meta: { title:'学习',login:true },
    component: () => import(/* webpackChunkName: 'examLive' */ './page/exam_live.vue'),
  },
  {
    path: '/supervise_test',
    name: 'examIsValid',
    meta: { title:'考场纪律' ,login:true},
    component: () => import(/* webpackChunkName: 'examLive' */ './page/examIsValid.vue'),
  },
]
export default routerArr